import { Component, NgZone, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';

import { GlobalState } from './global.state';
import { BaImageLoaderService, BaThemePreloader, BaThemeSpinner } from './theme/services';
import { BaThemeConfig } from './theme/theme.config';
import { layoutPaths } from './theme/theme.constants';
import 'style-loader!./app.scss';
import 'style-loader!./theme/initial.scss';
import { DisableDateService } from './common/services/disable-date-picker/disable-date-picker.service';
import { AppState } from './app.service';
import { HttpClient } from '@angular/common/http';
import { SwUpdateService } from './common/services/sw-update.service';
import { interval } from 'rxjs';

/*
 * App Component
 * Top Level Component
 */
@Component({
  selector: 'app',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit,OnDestroy {

  isMenuCollapsed: boolean = false; 
  private channel = new BroadcastChannel('appointment_sse');
  private isLeader = !localStorage.getItem('sse_leader');
  private eventSource: EventSource | null = null;
  private reconnectInterval = 5000; // 5 seconds
  private reconnectTimeout: any;

  constructor(private _state: GlobalState,
    private zone: NgZone,
    private appService: AppState,
    private _imageLoader: BaImageLoaderService,
    private _spinner: BaThemeSpinner,
    private viewContainerRef: ViewContainerRef,
    private themeConfig: BaThemeConfig,
    private http: HttpClient,
    private disableDateService: DisableDateService,
    private swUpdateService: SwUpdateService) {

      
      themeConfig.config();
      
      this._loadImages();
      
      this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
        this.isMenuCollapsed = isCollapsed;
      });

      this.http.get("assets/label-dictionary.json")
      .subscribe((data:any)=>{
        this._state.setGlobalSetting("label-dictionary",data)
        sessionStorage.setItem("label-dictionary", JSON.stringify(data));
      });
    
    //Uncomment following line to disable all logs
    //console.log = function() {}
  }

  ngOnInit(): void {
    this.loadAppConfig().then(() => {
      this.listenToAppointmentNotifications(); // only after config is ready
    });
    
    // Check for service worker updates on app startup
    this.checkForUpdates();
    interval(300000).subscribe(() => {
      this.checkForUpdates();
    });
  }

  private loadAppConfig(): Promise<void> {
    return new Promise((resolve) => {
      this.http
        .get("assets/appConfig.json")
        .subscribe(
          (data:any) => {
            this._state.setGlobalSetting("apiUrl", [data.apiUrl]);
            this._state.setGlobalSetting("contentUrl", [data.contentUrl]);
            resolve();
          },
          (error) => {
            // fallback URL
            this._state.setGlobalSetting("apiUrl", [
              "http://localhost:1782/api",
            ]);
            resolve();
          }
        );
    });
  }

  listenToAppointmentNotifications(): void {
    if (this.isLeader) {
      localStorage.setItem('sse_leader', 'true');
  
      const url =
        this._state.getGlobalSetting('apiUrl')[0] +
        '/Events/AppointmentNotification';
  
      this.zone.runOutsideAngular(() => {
        this.eventSource = new EventSource(url);
  
        this.eventSource.onmessage = (event) => {
          this.channel.postMessage(event.data);
        };
  
        this.eventSource.onerror = () => {
          this.cleanup();
          setTimeout(() => this.listenToAppointmentNotifications(), 3000);
        };
      });
    }
  
    // ALL tabs listen here
    this.channel.onmessage = (msg) => {
      console.log('message received from SSE', msg.data);
      this.zone.run(() => {
        const data = JSON.parse(msg.data);
        this.appService.publishNotification(data);
      });
    };
  }
 
  cleanup() {
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
    }
    localStorage.removeItem('sse_leader');
    if (this.reconnectTimeout) {
      clearTimeout(this.reconnectTimeout);
    }
  }

  ngOnDestroy() {
   this.cleanup();
  }

  public ngAfterViewInit(): void {
    // hide spinner once all loaders are completed
    BaThemePreloader.load().then((values) => {
      this._spinner.hide();
    });
  }

  private _loadImages(): void {
    // register some loaders
    BaThemePreloader.registerLoader(this._imageLoader.load(layoutPaths.images.root + 'sky-bg.jpg'));
  }

  /**
   * Check for service worker updates
   */
  private checkForUpdates(): void {
    // Check for updates immediately on startup
    this.swUpdateService.checkForUpdates();
    
    // Listen for update availability
    this.swUpdateService.updateAvailable$.subscribe(updateAvailable => {
      if (updateAvailable) {
        console.log('Update available');
      }
    });
  }

}
